import React, { useCallback, useState } from "react";
import "./Projects.css";
import { useTranslation } from "react-i18next";
import ArashTradeModal from "./ArashTradeModal";
import ProjectCard from "../card/ProjectCard";

const projects = [
    {
    title: "Skat Agent",
    lang1: "RAG - Pipeline",
    lang2: "Next.js - Supabase",
    imageSrc: "/assets/skat_agent.png",
    link: "https://skat-agent.vercel.app/da/dashboard",
  },
  {
    title: "AI customer-service",
    lang1: "Next.js - TypeScript",
    lang2: "Tailwind - TanStack Query",
    lang3: "Prompt Engineering",
    imageSrc: "/assets/support.png",
    link: "https://customer-service-powered-by-ai.vercel.app/emails",
  },
  {
    title: "TivoliBot",
    lang1: "React - TanStack Query",
    lang2: "Express - MySQL",
    lang3: "Prompt Engineering",
    imageSrc: "/assets/tivoli.png",
    link: "https://www.linkedin.com/posts/arashab_project-launch-tivoilbot-bringing-ai-activity-7386689554377846784-810j?utm_source=share&utm_medium=member_desktop&rcm=ACoAABEJADUBw_gB3YKcJqxFeIsB4dbrlofLIX4",
  },
  {
    title: "Chatbot",
    lang1: "React",
    lang2: "CSS",
    imageSrc: "/assets/gemini.png",
    link: "https://arashgemini.onrender.com/",
  },
  {
    title: "Mobile App",
    lang1: "React Native",
    lang2: "Expo",
    imageSrc: "/assets/arash-trade.png",
    openModal: true, // Special modal trigger
  },
  {
    title: "Ticket Booking",
    lang1: "C#  -  .NET",
    lang2: "Next.js",
    lang3: "TanStack Query",
    imageSrc: "/assets/ticket-booking.png",
    link: "https://www.linkedin.com/posts/arashab_fullstack-nextjs-dotnet-activity-7427664037565349888-Zmq0?utm_source=share&utm_medium=member_desktop&rcm=ACoAABEJADUBw_gB3YKcJqxFeIsB4dbrlofLIX4",
  },

  {
    title: "Game Zone",
    lang1: "React - Vite",
    lang2: "React Query - Zustand",
    imageSrc: "/assets/game-zone.png",
    link: "https://gamezone-68o0.onrender.com/",
  },
  {
    title: "Stock Market",
    lang1: "Next.js - TypeScript",
    lang2: "Shadcn - Radix UI",
    lang3: "MongoDB - Better Auth",
    imageSrc: "/assets/arash-stocks.png",
    link: "https://arash-stocks-2zfw.vercel.app/",
  },
  {
    title: "Restaurant",
    lang1: "Next.js - TypeScript",
    lang2: "Tailwind - TanStack Query",
    lang3: "Supabase -  UI/UX",
    imageSrc: "/assets/restaurant.png",
    link: "https://www.nysmag.dk/",
  },
  {
    title: "Job Bank",
    lang1: "C#  -  .NET",
    lang2: "React",
    imageSrc: "/assets/job-bank.png",
    link: "https://www.linkedin.com/posts/arashab_im-happy-to-share-jobbank-my-very-first-activity-7378356248431202305-NoxQ?utm_source=share&utm_medium=member_desktop&rcm=ACoAABEJADUBw_gB3YKcJqxFeIsB4dbrlofLIX4",
  },

  {
    title: "Online Shop",
    lang1: "React",
    lang2: "CSS",
    imageSrc: "/assets/shopping-site.png",
    link: "https://online-shop-gw9o.onrender.com/",
  },
  {
    title: "Landing Page",
    lang1: "React",
    lang2: "aos animation",
    imageSrc: "/assets/landing-page.png",
    link: "https://landing-page-c4je.onrender.com/",
  },
  // {
  //   title: "Social Network",
  //   lang1: "React",
  //   lang2: "Material UI",
  //   imageSrc: "/assets/social-network.png",
  //   link: "https://social-network-ui.onrender.com/",
  // },
];

const Projects = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenModal = useCallback(() => setModalOpen(true), []);

  return (
    <section id="projects" className="projects wrapper">
      <div className="section-gap"></div>
      <h2 className="section-title">{t("Projekter")}</h2>

      <div className="projects-wrapper">
        {projects.map((project, index) => {
          return (
            <ProjectCard
              key={project.title}
              title={project.title}
              imageSrc={project.imageSrc}
              lang1={project.lang1}
              lang2={project.lang2}
              lang3={project.lang3}
              link={project.link}
              onClick={project.openModal ? handleOpenModal : undefined}
            />
          );
        })}
      </div>

      <ArashTradeModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </section>
  );
};

export default Projects;
